<template lang="pug">
  div
    portal(to="pageTitle")
      span Добавить баннер

    v-container
      Settings(
        :dateStart="dateStart",
        :dateEnd="dateEnd",
        :active="active",
        :countriesExcluded="countriesExcluded"
        :countriesIncluded="countriesIncluded"
        :sitesExcluded="sitesExcluded"
        :sitesIncluded="sitesIncluded"
        :languages="languages"
        :locale="locale"

        @dateStartChanged="onDateStartChanged"
        @dateEndChanged="onDateEndChanged"
        @activeChanged="onActiveChanged"
        @countriesExcludedChanged="onCountriesExcludedChanged"
        @countriesIncludedChanged="onCountriesIncludedChanged"
        @sitesExcludedChanged="onSitesExcludedChanged"
        @sitesIncludedChanged="onSitesIncludedChanged"
        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :name="name"
        :text="text"
        :link="link"
        :image="getLocalValue(image)"
        @nameChanged="onNameChanged"
        @textChanged="onTextChanged"
        @linkChanged="onLinkChanged"
        @imageChanged="onImageChanged"
        @delImageChanged="onDelImageChanged"
      )

      .mt-10

      Controls(
        @save="onSave"
      )
</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import AddBannerGQL from '../../graphql/private/Banner/AddBanner.gql'

export default {
  name: 'banners__add',

  mixins: [Mixin, notify],

  components: {
    Settings,
    Content,
    Controls,
  },

  methods: {
    getTime(tin) {
      if (!tin) {
        return null
      }

      return new Date(tin).toISOString()
    },
    async onSave() {
      try {
        if (this.delImage) {
          this.imageFile = null
        }

        const dayStart = this.getTime(this.dateStart)
        const dayEnd = this.getTime(this.dateEnd)

        const res = await this.$apollo.mutate({
          mutation: AddBannerGQL,
          variables: {
            input: {
              active: this.active,
              countriesExcluded: this.countriesExcluded,
              countriesIncluded: this.countriesIncluded,
              sitesExcluded: this.sitesExcluded,
              sitesIncluded: this.sitesIncluded,
              dateStart: dayStart,
              dateEnd: dayEnd,
              image: this.imageFile,
              delImage: this.delImage,
              link: this.link,
              locale: this.locale,
              name: this.name,
              text: this.text,
            },
          },
        })

        this.imageFile = null
        this.delImage = false

        this.notify({
          text: 'Баннер обновлен!',
        })

        await this.$router.push({
          name: 'banners__id',
          params: {
            id: res.data.addBanner,
          },
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },
  },
}
</script>
